/**
 * @generated SignedSource<<6543a895de1722aed62d13166ec81656>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
import { FragmentRefs } from "relay-runtime";
export type TagLink_tag$data = {
  readonly color: Colors;
  readonly homePanelGroup: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly label: string;
  readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_object">;
  readonly " $fragmentType": "TagLink_tag";
};
export type TagLink_tag$key = {
  readonly " $data"?: TagLink_tag$data;
  readonly " $fragmentSpreads": FragmentRefs<"TagLink_tag">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TagLink_tag",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelGroup",
      "kind": "LinkedField",
      "name": "homePanelGroup",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomePanelGroupsMenu_object"
    }
  ],
  "type": "Tag",
  "abstractKey": null
};
})();

(node as any).hash = "f1c71064fe6f5cd1c3e50536f6ff4338";

export default node;
